export enum XHedgeEventBusEvents {
  SHOW_UPDATES = 'SHOW_UPDATES',
}
